// extracted by mini-css-extract-plugin
export default {"container":"show-hours__container___2D-EP","weekday-font":"show-hours__weekday-font___1W-lv"};